Vue.component('state-settings', {
    template: `
    <div class="vertical-center">
        <div class="app-card text-center">
            <app-game-settings></app-game-settings>
        </div>
    </div>
    `
})